<template>
  <v-dialog
    v-model="visible"
    persistent
    max-width="600px"
  >
    <v-card>
      <v-card-title>
        <span class="headline">{{ headline }}</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-form
            ref="myForm"
            v-model="formValid"
          >
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="name"
                  :rules="rules.required"
                  :label="$t('Name')"
                  dense
                ></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-text-field
                  v-model="slug"
                  :rules="rules.required"
                  :label="$t('Slug')"
                  dense
                ></v-text-field>
              </v-col>

              <v-col
                cols="12"
                sm="6"
              >
                <v-autocomplete
                  v-model="selectedPermissions"
                  :rules="rules.permissions"
                  :items="permissions"
                  :label="$t('Permissions')"
                  item-text="name"
                  item-value="name"
                  dense
                  multiple
                  clearable
                >
                  <template
                    slot="selection"
                    slot-scope="data"
                  >
                    {{ data.item.name }}
                  </template>
                  <template
                    slot="item"
                    slot-scope="data"
                  >
                    <div>{{ data.item.name }}</div>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="error"
          outlined
          @click="$parent.isDialogVisible = false"
        >
          {{ $t('Close') }}
        </v-btn>
        <v-btn
          v-if="role"
          color="success"
          @click="update(role)"
        >
          {{ $t('Save') }}
        </v-btn>
        <v-btn
          v-else
          color="success"
          @click="add()"
        >
          {{ $t('Save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import store from '@/store'
import { mapState } from 'vuex'

export default {
  props: {
    role: Object,
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formValid: false,
      rules: {
        required: [value => !!value || this.$t('Required')],
        permissions: [v => !!(v && v.length) || this.$t('Required')],
      },
      name: '',
      slug: '',
      selectedPermissions: [],
    }
  },
  watch: {
    visible() {
      if (this.role) {
        this.name = this.role.name
        this.slug = this.role.slug
        this.selectedPermissions = this.role.permissions_names
      } else {
        this.name = ''
        this.slug = ''
        this.selectedPermissions = []
      }
    },
  },
  mounted() {
    store.dispatch('app/fetchPermissions')
  },
  methods: {
    update() {
      this.$refs.myForm.validate()
      if (this.formValid) {
        store.dispatch('app/updateRole', {
          role: {
            id: this.role.id,
            name: this.name,
            slug: this.validatedSlug,
            permissions: this.selectedPermissions,
          },
        }).then(response => {
          if (response.data.success) {
            this.$parent.isDialogVisible = false
          } else {
            console.log(`Error: ${response.data.message}`)
          }
        }, error => {
          console.log(`Error: ${error}`)
        })
      }
    },
    add() {
      this.$refs.myForm.validate()
      if (this.formValid) {
        store.dispatch('app/storeRole', {
          role: {
            name: this.name,
            slug: this.validatedSlug,
            permissions: this.selectedPermissions,
          },
        }).then(response => {
          if (response.data.success) {
            this.$parent.isDialogVisible = false
          } else {
            console.log(`Error: ${response.data.message}`)
          }
        }, error => {
          console.log(`Error: ${error}`)
        })
      }
    },
  },
  computed:
    {
      ...mapState('app', ['permissions']),
      headline() {
        if (this.role) {
          return this.$t('Edit Role')
        }

        return this.$t('Add Role')
      },
      validatedSlug() {
        let validated = this.slug.toLowerCase()
        validated = validated.replace('ö', 'oe')
        validated = validated.replace('ä', 'ae')
        validated = validated.replace('ü', 'ue')
        validated = validated.replace(/[^a-z0-9]+/g, '_')
        validated.replace(/(_)\\1{1}/, '_')

        return validated
      },
    },

  setup() {
  },
}
</script>
